import { render, staticRenderFns } from "./MSOCoupons.vue?vue&type=template&id=dd32e414&"
import script from "./MSOCoupons.vue?vue&type=script&lang=js&"
export * from "./MSOCoupons.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports